<template>
  <div>
    <div v-if="!spinner && buses.length == 0" v-center>
      <h1>no hay Buses</h1>
    </div>
    <Spinner v-if="spinner" color="#fedd00" />
  </div>
</template>

<script>
import Spinner from "vue-spinner/src/ScaleLoader.vue";
export default {
  components: {
    Spinner
  },
  props: ['spinner', 'buses']
};
</script>